import { Box, Typography } from "@mui/material"
import { KeyCaptionProps } from "./types"
import { useStyles } from "./styles"
import React from "react"

export const KeyCaption = ({ value, caption, captionProps, valueProps }: KeyCaptionProps) => {
    const styles = useStyles()

    return (
        <Box sx={styles.root}>
            {typeof caption === 'string' ? <Typography variant="text_grey" fontWeight='500' {...captionProps}>{caption}</Typography> : caption}

            {typeof value === 'string' ? <Typography variant="text_grey" fontWeight='bold' {...valueProps}>{value}</Typography> : value}
        </Box>
    )
}
export const CaptionKey = ({ value, caption, captionProps, valueProps }: KeyCaptionProps) => {
    const styles = useStyles()

    return (
        <Box sx={styles.root}>
            {typeof value === 'string' ? <Typography variant="text_grey" fontWeight='bold'  {...valueProps}>{value}</Typography> : value}

            {typeof caption === 'string' ? <Typography variant="text_grey" fontWeight='500' {...captionProps}>{caption}</Typography> : caption}
        </Box>
    )
}
export const CaptionKeyVertical = ({ value, caption, captionProps, valueProps, center }: KeyCaptionProps) => {
    const styles = useStyles()

    return (
        <Box sx={styles.rootVertical(!!center)}>
            {typeof caption === 'string' ? <Typography variant="text_grey" fontWeight='bold' {...captionProps}>{caption}</Typography> : caption}

            {typeof value === 'string' ? <Typography variant="text_grey" fontWeight='500' {...valueProps}>{value}</Typography> : value}
        </Box>
    )
}

export const KeyCaptionVertical = ({ value, caption, captionProps, valueProps, center }: KeyCaptionProps) => {
    const styles = useStyles()

    return (
        <Box sx={styles.rootVertical(!!center)}>
            {typeof value === 'string' ? <Typography variant="text_grey" fontWeight='500' {...valueProps}>{value}</Typography> : value}

            {typeof caption === 'string' ? <Typography variant="text_grey" fontWeight='bold' {...captionProps}>{caption}</Typography> : caption}
        </Box>
    )
}